import {  useRef, useState, useEffect } from "react";
import {  useSelector } from "react-redux";
import "./Steps.css";
import dayjs from 'dayjs';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import CustomCalendar from '../../appointments/calendar/CustomCalendar'; // Import the custom calendar
import { Button } from '@mui/material';
import { useForwardChevron } from '../../../i18n/DirectionalIcons';
import SelectionPath from '../SelectionPath';
import { useT } from "../../../i18n";

function Step4(props) {
    console.log("step4","start");
  const t = useT();
  const FwdChevron = useForwardChevron();
  const {user} = useSelector((state) => state.auth)
  const department = user?.departments.find(d => d.id == props.formData.department_id)
 
            //const slots = props.formData.doctor.slots.sort((a, b) => dayjs(a.wdate).isBefore(dayjs(b.wdate)));
  const slots = props.formData.doctor.slots.sort((a, b) => {
  const dateA = dayjs(a.wdate);
  const dateB = dayjs(b.wdate);
  const timeA = dayjs(a.start_time, 'HH:mm:ss');
  const timeB = dayjs(b.start_time, 'HH:mm:ss');

  // Compare dates first
  if (!dateA.isSame(dateB)) {
    return dateA - dateB;
  }

  // Dates are the same, compare times
  return timeA - timeB;
});

  const firstSlot = slots[0];
  // A8: when returning to this step (e.g. back from confirmation), reopen on the previously chosen
  // slot's date and re-select that time. Match by id against the current slots so a removed slot
  // just falls back to no selection.
  const preTime = props.formData.timeData
    ? (slots.find(s => s.id === props.formData.timeData.id) || null)
    : null;
  const initialValue = dayjs((preTime || firstSlot).wdate);
  
 const [highlightedDays, setHighlightedDays] = useState(
 slots.filter(s =>
 dayjs(s.wdate).isSame(dayjs(initialValue).startOf('month')) || 
(dayjs(s.wdate).isBefore(dayjs(initialValue).add(1, 'month').startOf('month')) &&  
dayjs(s.wdate).isAfter(dayjs(initialValue).startOf('month'))))
    .map(s => Number(dayjs(s.wdate).format('DD')))
  );
  

  const [currentDate, setCurrentDate] = useState(initialValue);
  
  const [times, setTimes] = useState(slots.filter(s => s.wdate == initialValue.format('YYYY-MM-DD')));
  const [selectedTime, setSelectedTime] = useState(preTime);
  const requestAbortController = useRef(null);

  // Show a bottom fade + chevron when the time list overflows, so the user
  // knows there are more slots below. Hidden once scrolled to the bottom.
  const timeRef = useRef(null);
  const [showFade, setShowFade] = useState(false);
  /* C1 — מצב תפיסת-השעה. `holding` מונע לחיצה כפולה בזמן הבקשה;
     `takenMsg` מציג למה נשארנו במסך. */
  const [holding, setHolding] = useState(false);
  /* ★ F1 — דגל ולא טקסט, כדי שההודעה תתורגם-מחדש בהחלפת-שפה. */
  const [slotTaken, setSlotTaken] = useState(false);
  // The list shows a fixed 3 rows (3x3); show the scroll button only when
  // there are more rows, and hide it once scrolled to the bottom.
  const checkFade = () => {
    const el = timeRef.current;
    if (el) setShowFade(el.scrollHeight - el.scrollTop - el.clientHeight > 6);
  };
  useEffect(() => {
    const el = timeRef.current;
    // a new day/month: smoothly scroll the list back up to the top
    if (el) el.scrollTo({ top: 0, behavior: "smooth" });
    const raf = requestAnimationFrame(checkFade);
    return () => cancelAnimationFrame(raf);
  }, [times]);
  // Re-evaluate the fade/chevron when the visible height changes — rotation, and the
  // mobile URL-bar showing/hiding shrinks/grows the locked time window (which changes
  // whether the list overflows). Without this the chevron hint goes stale.
  useEffect(() => {
    const onResize = () => checkFade();
    window.addEventListener('resize', onResize);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', onResize);
    };
  }, []);
  const scrollTimesDown = () => {
    const el = timeRef.current;
    if (!el) return;
    // advance by exactly 2 rows, ALIGNED to row tops, so the next hours never appear
    // cut off at the top. Loop back to the top once the end is reached.
    const slots = el.querySelectorAll(".time-slot");
    const stride = slots.length > 4 ? slots[4].offsetTop - slots[0].offsetTop : 52;
    const maxScroll = el.scrollHeight - el.clientHeight;
    if (maxScroll - el.scrollTop < 6) { el.scrollTo({ top: 0, behavior: "smooth" }); return; }
    const curRow = Math.round(el.scrollTop / stride);
    el.scrollTo({ top: Math.min((curRow + 2) * stride, maxScroll), behavior: "smooth" });
  };

  


const ServerDay = (props) => {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  const isSelected =
    !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;

  return (
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} disabled={!isSelected} day={day} />

  );
}

const Change = (value) => {
  setCurrentDate(value);

  let times = slots.filter(s => s.wdate == value.format('YYYY-MM-DD'));
  setTimes(times)
  setSelectedTime(null)
}

// pick a time (highlight it) — do NOT advance yet
const ChooseTime = (time) => {
  setSelectedTime(time);
  /* ★ ההודעות נעלמות ברגע שהאזרח פועל. הודעה שנשארת אחרי שהמשתמש כבר
     תיקן את המצב נקראת כאילו התקלה עדיין קיימת. */
  if (slotTaken) { setSlotTaken(false); }
  if (props.holdExpired && typeof props.clearHoldExpired === 'function') {
    props.clearHoldExpired();
  }
}

// confirm the chosen time and move on
/* ★★ C1 — לפני המעבר למסך-האישור **תופסים את השעה**. עד כה השעה נתפסה רק
   בלחיצה הסופית, ולכן אזרח שמילא פרטים דקה שלמה יכול היה לגלות בסוף
   ש\"אין יותר תורים\" — אחרי שהשקיע את כל המסלול.
   ★ אם ההחזקה כבויה בהגדרות או נכשלה ברשת — ממשיכים בדיוק כמו קודם. */
const Confirm = async () => {
  if (!selectedTime || holding) return;
  const advance = () => {
    props.setFormData({...props.formData,
      slot_data_id: selectedTime.id,
      appointed_time: selectedTime.start_time,
      timeData: selectedTime,
    })
    props.next()
  };
  if (typeof props.onHoldTime !== 'function') { advance(); return; }
  setHolding(true);
  const res = await props.onHoldTime(selectedTime.id,
    selectedTime.wdate + ' ' + selectedTime.start_time);
  setHolding(false);
  if (res && res.ok === false) {
    /* השעה נתפסה בין הצגת-הרשימה ללחיצה. מודיעים ומרעננים את הזמינות
       במקום להעביר למסך-אישור על שעה שכבר אינה קיימת. */
    setSlotTaken(true);
    setSelectedTime(null);
    return;
  }
  advance();
}

const handleMonthChange = (date) => {
  // Clear current times since we are moving to a new month.
  setTimes([]);
  setSelectedTime(null);

  // Calculate start and end of the new month.
  const monthStart = dayjs(date).startOf('month');
  const monthEnd = dayjs(date).endOf('month');

  // Filter slots in the new month.
  const slotsInMonth = slots.filter((s) => {
    const sDate = dayjs(s.wdate);
    return sDate.isBetween(monthStart, monthEnd, 'day', '[]');
  });

  // Update the highlighted days.
  setHighlightedDays(
    slotsInMonth.map(s => Number(dayjs(s.wdate).format('DD')))
  );

  // If there are available slots in the month, select the first available day.
  if (slotsInMonth.length > 0) {
    // Get all the day numbers in the month and choose the minimum.
    const firstAvailableDay = Math.min(
      ...slotsInMonth.map((s) => dayjs(s.wdate).date())
    );

    // Construct the new current date with the first available day.
    const newCurrentDate = dayjs(date).date(firstAvailableDay);

    // Update the parent state.
    setCurrentDate(newCurrentDate);

    // Also update the times for the selected day.
    const newTimes = slots.filter((s) =>
      dayjs(s.wdate).isSame(newCurrentDate, 'day')
    );
    setTimes(newTimes);
  } else {
    // If no slots, you might decide to update currentDate to the new month start
    // or keep it unchanged.
    setCurrentDate(date);
    setTimes([]);
  }
};

  
  return (
    <div className="step step4">
      {/* Same title element (h5) + styling as "בחר מחלקה" (Step2) / "בחר שירות" (Step3),
          with the chosen "מחלקה · שירות" breadcrumb below it (smaller — see SelectionPath.css). */}
      <h5>{t("step4.title")}</h5>
      <SelectionPath departmentId={props.formData.department_id} serviceTitle={props.formData.doctor?.title} />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CustomCalendar
  views={["day"]}
  value={currentDate} 
  onChange={Change}
  onMonthChange={handleMonthChange}
  minDate={currentDate}
  slots={{ day: ServerDay }}
  slotProps={{ day: { highlightedDays } }}
/>

      </LocalizationProvider>

      <div className="time-section">
        <div className={'time-warp-wrap' + (showFade ? ' has-more' : '')}>
          <div className="time-warp" ref={timeRef} onScroll={checkFade}>
          {times.map(time => {
            // a11y (WCAG 2.1.1 / 4.1.2): the time pills are <span>s, so they must expose
            // a button role, be keyboard-focusable, activate on Enter/Space, and announce
            // their selected state (aria-pressed) to screen readers.
            const label = dayjs('2023-12-12 ' + time.start_time).format('HH:mm');
            const isActive = selectedTime?.id === time.id;
            return (
              <span key={time.id}
                role="button"
                tabIndex={0}
                aria-pressed={isActive}
                aria-label={t('step4.chooseTimeAria', { time: label })}
                className={'time-slot' + (isActive ? ' active' : '')}
                onClick={() => ChooseTime(time)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ChooseTime(time); } }}>{
                label
                }</span>
            );
          })}
          </div>
          {showFade && (
            <button
              type="button"
              className="time-scroll-btn"
              onClick={scrollTimesDown}
              aria-label={t("step4.scrollMoreTimes")}
            >
              <KeyboardArrowDownRoundedIcon />
            </button>
          )}
        </div>
      </div>

      {/* ★ שתי ההודעות שהאזרח באמת רואה כשמשהו משתבש. שתיהן מוצגות **במסך
          בחירת-השעה** ולא כפופ-אפ: המשימה הבאה שלו היא לבחור שעה, וההודעה
          צריכה לשבת ליד הרשימה שבה יבחר. */}
      {props.holdExpired && (
        <div className="hold_note hold_note_warn" role="status">
          {t("step4.holdExpired")}
        </div>
      )}
      {slotTaken && (
        <div className="hold_note hold_note_warn" role="status">{t("step4.slotTaken")}</div>
      )}

      <Button
        variant="contained"
        disabled={!selectedTime || holding}
        className="next-btn"
        onClick={Confirm}
        sx={{ borderRadius: 0, fontSize: 18 }}
        endIcon={<FwdChevron />}
      >
        {t("common.next")}
      </Button>
    </div>
  );
}

export default Step4;
